import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Gallery from './Gallery';
import Events from './Events';
import Contact from './Contact';
import Articles from './Articles';
import DesktopVideoCards from "/components/Video/DesktopVideoCards";
import { DesktopVideoCardsSection, MobileVideoCardsSection } from '/components/CardsSection/videoCardsSection';
import BrandVideos from './BrandVideos';
import Hidden from '@material-ui/core/Hidden';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    marginTop: 12,
  },
  tabsRoot:{
    borderBottom: '1px solid #b1b1b1'
  },
  tabsScroller:{
    marginBottom: '-17px!important'
  },
  tabsIndicator: {
    height: 4
  }
});

class BrandTabs extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };
  readAllClick = (index) => {
    this.setState({ value: index });
  };

  render() {
    const { classes, mobileMaxNum, newsItems, brandEvents, eventNextFunc, videoItems, brandVideos, eventItems, videoNextFunc, gallery, articles, carouselItems, func, links, brandProfileSlug, brandProfileName, brandNextState, itemsMobile, itemsDesktop, forMiddleAdsMobile, forMiddleAdsDesktop } = this.props;
    const { value } = this.state;

    return (
      <div className={classes.root}>
          <Tabs
           classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator, scroller: classes.tabsScroller}}
            value={value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Home" />
            <Tab label="Articles" />
            <Tab label="Videos" />
            <Tab label="Gallery" />
            <Tab label="Events" />
            <Tab label="Contact Us" />
          </Tabs>
        {value === 0 && 
          <div style={{paddingBottom: 24, paddingTop: 0}}>
            <Articles brandProfileName={brandProfileName} mobileMaxNum='3' readAllClick={this.readAllClick} isArticleTab={false} brandArticles={articles} carousel={carouselItems} btn={func} nextItemsMobile={itemsMobile} nextItemsDesktop={itemsDesktop} />
            { brandVideos && brandVideos.length > 0 && 
            <>
              <Hidden smDown>
              <DesktopVideoCardsSection 
                contentTitle={`${brandProfileName} Videos`} 
                brandTab={true}
                color='#fff'
                readAll={`View All Latest ${brandProfileName} Videos`}
                newsItems={null} 
                items={brandVideos}
                maxNum='4'
                readAllClick={this.readAllClick}
                brandProfileName={brandProfileName}
                />
              </Hidden>
              <Hidden only={['md', 'lg', 'xl']}>
                <MobileVideoCardsSection 
                 contentTitle={`${brandProfileName} Videos`} 
                 brandTab={true}
                 color='#fff'
                 readAll={`View All Latest ${brandProfileName} Videos`}
                 newsItems={null} 
                 items={brandVideos}
                 maxNum='4'
                 readAllClick={this.readAllClick}
                 brandProfileName={brandProfileName}
                />
              </Hidden>
            </>
            }
          </div>
        }
        {value === 1 && <Articles mobileMaxNum={mobileMaxNum} isArticleTab={true} brandArticles={articles} carousel={carouselItems} btn={func} nextItemsMobile={itemsMobile} nextItemsDesktop={itemsDesktop} />}
        {value === 2 && <BrandVideos videos={brandVideos} btn={func} videoItems={videoItems} videoNextBtn={videoNextFunc} />}
        {value === 3 && <div style={{padding: 24, paddingTop: 0}}><Gallery photos={gallery} /></div>}
        {value === 4 && <Events nextEventItems={eventItems} thereIsNo="There are no events." eventNextBtn={eventNextFunc} events={brandEvents} />}
        {value === 5 && <TabContainer><Contact brandSlug={brandProfileSlug} /></TabContainer>}
  
      </div>
    );
  }
}

BrandTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BrandTabs);
